import(/* webpackMode: "eager", webpackExports: ["CasinoCard"] */ "/opt/hotlistcasino/frontend/src/components/CasinoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCircleImage"] */ "/opt/hotlistcasino/frontend/src/components/HeroCircleImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeGameCard"] */ "/opt/hotlistcasino/frontend/src/components/HomeGameCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedLink"] */ "/opt/hotlistcasino/frontend/src/components/LocalizedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionStagger"] */ "/opt/hotlistcasino/frontend/src/components/MotionStagger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProvidersCarousel"] */ "/opt/hotlistcasino/frontend/src/components/ProvidersCarousel.tsx");
